import toStartCase from "@hypertune/sdk/src/shared/helpers/toStartCase";
import { LabeledOption } from "../components/Dropdown";

export default function toLabeledOption<T extends string>(
  string: T,
  icon?: React.ReactNode
): LabeledOption<T> {
  return { value: string, label: toStartCase(string), icon };
}
